import { Injectable } from '@angular/core';

/** Which ngx-spinner instance is mounted (must match DOM in app.component). */
export type LoadingSpinnerShell = 'guest' | 'main';

/**
 * Tracks which spinner name GlobalLoadingService should use.
 * App root updates this when layout switches (guest vs sidebar + content).
 */
@Injectable({ providedIn: 'root' })
export class LoadingSpinnerShellService {
  activeName: LoadingSpinnerShell = 'guest';
}
